__turbopack_context__.v({
  "copy": "nav-item-module-scss-module__soT8Ca__copy",
  "externalIcon": "nav-item-module-scss-module__soT8Ca__externalIcon",
  "externalLink": "nav-item-module-scss-module__soT8Ca__externalLink",
  "icon": "nav-item-module-scss-module__soT8Ca__icon",
  "isOpen": "nav-item-module-scss-module__soT8Ca__isOpen",
  "navItem": "nav-item-module-scss-module__soT8Ca__navItem",
  "slideAndFadeIn": "nav-item-module-scss-module__soT8Ca__slideAndFadeIn",
  "subNav": "nav-item-module-scss-module__soT8Ca__subNav",
  "subNavList": "nav-item-module-scss-module__soT8Ca__subNavList",
  "subNavToggle": "nav-item-module-scss-module__soT8Ca__subNavToggle",
});
